import { ReactNode } from 'react';
import Menu from '../Menu';
import * as Style from './style';
import { MenuItem } from 'menu/MenuItem';

interface ContextMenuProps {
	menuItems: MenuItem[] | null;
	children: ReactNode | string;
}

const ContextMenu = ({ menuItems, children }: ContextMenuProps) => {
	return (
		<Menu menuItems={menuItems} Style={Style}>
			{children}
		</Menu>
	);
};

export default ContextMenu;
